module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon-think-1dba35aeec7fa1637d94b51ac7753ea3.svg";